import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Navigation } from '../../navigation/react-redux-nav';
import { setConnectedProduct } from '../../store/ducks/connected-product';
import MuiRaisedButton from 'material-ui/RaisedButton';
import WearableButton from '../../components/wearable-button';
import Icon, { NAMES } from '@ifit/react-icons';
import styles from '../../shared-styles';

import './index.css';

export class WearableSelectionPage extends Component {
  constructor(props) {
    super(props);
    this.handleVueSelected = () => props.handleProductSelected('vue');
    this.handleAxisHRSelected = () => props.handleProductSelected('axis hr');
    this.handlePhoneSelected = () => props.handleProductSelected('phone');
    this.handleTrackSelected = () => props.handleProductSelected('track');
  };

  render() {
    return (
      <div className="wearable-selection">
        <Navigation.Backward>
          <Icon
            className="back-arrow"
            name={ NAMES.ARROW_LEFT }
            color={ 'white' }
            size={ 24 }
            unitSize="px"
          />
        </Navigation.Backward>

        <div className="wearable-navigation">
          <h1>Which product are you setting up?</h1>

          <Navigation.Forward onClick={ this.handleVueSelected }>
            <WearableButton type="vue" />
          </Navigation.Forward>
          <Navigation.Forward onClick={ this.handleAxisHRSelected }>
            <WearableButton type="axis" />
          </Navigation.Forward>
          <Navigation.Forward onClick={ this.handlePhoneSelected }>
            <MuiRaisedButton
              className="button"
              label="Set up phone only"
              fullWidth={ true }
              style={ styles.buttonStyle }
              buttonStyle={ styles.buttonBorderStyle }
              labelStyle={ styles.buttonLabelStyle }
            />
          </Navigation.Forward>
        </div>
        <div className="dashed-title-container">
          <div className="lines" />
          <h2>Don't see your wearable?</h2>
          <div className="lines" />
        </div>
        <div className="wearable-content">
          <p>The following wearables require the iFit Track app:</p>
          <ul>
            <li>Link</li>
            <li>Classic</li>
            <li>Duo</li>
            <li>Act</li>
            <li>Active</li>
          </ul>

          <Navigation.Forward onClick={ this.handleTrackSelected }>
            <MuiRaisedButton
              className="button"
              label="Download Track app"
              fullWidth={ true }
              style={ styles.buttonStyle }
              buttonStyle={ styles.buttonBorderStyle }
              labelStyle={ styles.buttonLabelStyle }
            />
          </Navigation.Forward>
        </div>
      </div>
    );
  }
}

WearableSelectionPage.propTypes = {
  handleProductSelected: PropTypes.func.isRequired
};

export default connect(
  null,
  (dispatch) => {
    return {
      handleProductSelected: product => dispatch(setConnectedProduct(product))
    };
  }
)(WearableSelectionPage);
